var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 1.99967V7.99967C10.0007 8.73301 9.40065 9.33301 8.66732 9.33301H1.33398V3.99967C1.33398 2.52634 2.52732 1.33301 4.00065 1.33301H9.33398C9.70065 1.33301 10.0007 1.63301 10.0007 1.99967Z",
    fill: "#1D2939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.6673 9.33301V11.333C14.6673 12.4397 13.774 13.333 12.6673 13.333H12.0007C12.0007 12.5997 11.4007 11.9997 10.6673 11.9997C9.93398 11.9997 9.33398 12.5997 9.33398 13.333H6.66732C6.66732 12.5997 6.06732 11.9997 5.33398 11.9997C4.60065 11.9997 4.00065 12.5997 4.00065 13.333H3.33398C2.22732 13.333 1.33398 12.4397 1.33398 11.333V9.33301H8.66732C9.40065 9.33301 10.0007 8.73301 10.0007 7.99967V3.33301H11.2273C11.7073 3.33301 12.1473 3.59301 12.3873 4.00635L13.5273 5.99967H12.6673C12.3007 5.99967 12.0007 6.29967 12.0007 6.66634V8.66634C12.0007 9.03301 12.3007 9.33301 12.6673 9.33301H14.6673Z",
    fill: "#1D2939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 14.6667C6.06971 14.6667 6.66667 14.0697 6.66667 13.3333C6.66667 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z",
    fill: "#1D2939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 14.6667C11.4037 14.6667 12.0007 14.0697 12.0007 13.3333C12.0007 12.597 11.4037 12 10.6673 12C9.93094 12 9.33398 12.597 9.33398 13.3333C9.33398 14.0697 9.93094 14.6667 10.6673 14.6667Z",
    fill: "#1D2939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8.35335V9.33333H12.6667C12.3 9.33333 12 9.03333 12 8.66667V6.66667C12 6.3 12.3 6 12.6667 6H13.5267L14.4933 7.69332C14.6067 7.89332 14.6667 8.12002 14.6667 8.35335Z",
    fill: "#1D2939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/truckIcon.dd851017b11d8a389f5e085548d7c4bf.svg";
export { ForwardRef as ReactComponent };